import { Outlet, createFileRoute } from '@tanstack/react-router'
import { ModuleGuard } from '@/components/module-guard'

export const Route = createFileRoute('/hr/lifecycle')({
  component: LifecycleLayout,
})

function LifecycleLayout() {
  return (
    <ModuleGuard moduleKey="hr">
      <Outlet />
    </ModuleGuard>
  )
}
